import { useState, useRef } from 'react'
import Button from '../Button.jsx'
import { CreateImage } from '../../repo/ImagesRepo.js'

export default function AdminImagesForm({errors, isSubmitting}) {
  const [selectedFile, setSelectedFile] = useState(null);
  const imageRef = useRef()

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0])
  };

  const handleFormSubmit = async () => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const base64String = event.target.result;
      CreateImage({ content: base64String, filename: selectedFile.name })
    };

    reader.onerror = () => {
      console.log('Error reading file.');
    };

    reader.readAsDataURL(selectedFile);
  };

  return(
    <>
      <input type="file" name="image" id="image" ref={imageRef} onChange={handleFileChange} />

      <Button styleName="blue" onClick={handleFormSubmit} disabled={isSubmitting} >
        {isSubmitting ? 'Salvando...' : 'Salvar'}
      </Button>
    </>
  )
}
